import {Item, Rental} from "../types";
import {
    Avatar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useAsync,
    useBoxes,
    usePlatform
} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {Box, Occupancy} from "@variocube/app-api";
import {ItemTableCell} from "./ItemTableCell";
import {useLocalization} from "../../i18n";


export interface BoxTabProps {
    rentals: Rental[];
    items: Item[];
    onOpen: (box: Box) => void;
}

export function BoxTab({items, rentals, onOpen}: BoxTabProps) {
    const platform = usePlatform();
    const {result: occupancies} = useAsync(() => platform.getOccupancies(), [platform]);
    const boxes = useBoxes();

    return (
        <BoxTable
            boxes={boxes || []}
            items={items}
            occupancies={occupancies || []}
            rentals={rentals}
            onOpen={onOpen}
        />
    );
}

export interface BoxTableProps {
    boxes: Box[];
    items: Item[];
    occupancies: Occupancy[];
    rentals: Rental[];
    onOpen: (box: Box) => void;
}

export function BoxTable({boxes, items, occupancies, rentals, onOpen}: BoxTableProps) {
    //const strings = useStrings();
    const {t} = useLocalization();
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{t("Box")}</TableCell>
                    <TableCell>{t("Item")}</TableCell>
                    <TableCell>{t("Rental")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {boxes.map(box => {

                    const occupancy = occupancies.find(occupancy => occupancy.boxNumber == box.number);
                    const item = occupancy && items.find(item => item.uuid == occupancy.content.item);
                    const rental = occupancy && rentals.find(rental => rental.uuid == occupancy.content.rental);

                    return (
                        <BoxRow
                            key={box.number}
                            box={box}
                            item={item}
                            rental={rental}
                            onOpen={onOpen}
                        />
                    )
                })}
            </TableBody>
        </Table>
    );
}

export interface BoxRowProps {
    box: Box;
    rental?: Rental;
    item?: Item;
    onOpen: (box: Box) => void;
}

export function BoxRow({box, rental, item, onOpen}: BoxRowProps) {
    const handleClick = useCallback(() => onOpen(box), [onOpen, box]);
    return (
        <TableRow onClick={handleClick}>
            <TableCell>
                <Avatar size={1.5}>{box.number}</Avatar>
            </TableCell>
            <ItemTableCell item={item}/>
            <TableCell>
                {rental?.borrower.name}
            </TableCell>
        </TableRow>
    );
}
